import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import QRCode from "qrcode";
import { Button } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import AdminSidebar from "../../layouts/AdminSidebar";
import { generateSku } from "../../util/utils";
import { authCall } from "../../../services";
import AppConstants from "../../../appConstants";

const shareUrl = process.env.REACT_APP_STAFF_URL;
const USERTYPE = [
  { value: "Activity", label: "Activity" },
  { value: "Restaurant", label: "Restaurant" },
  { value: "Bar", label: "Bar" },
  { value: "Hotel", label: "Hotel" },
  { value: "Generic", label: "Generic" },
];

const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#bababa",
    border: "2px solid #fff",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#007BFF"
      : state.isFocused
      ? "#e0e0e0"
      : "#fff",
    color: state.isSelected ? "#fff" : "#000",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#000",
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: "#fff",
    zIndex: 9999,
  }),
  menuList: (provided, state) => ({
    ...provided,
    backgroundColor: "#fff",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#383636",
    // fontWeight: 600,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#383636",
  }),
};

function AddHotelStaff() {
  const qrRef = useRef();
  const validator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const { current } = useSelector((state) => state.user);
  const { details } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [hotels, setHotels] = useState([]);
  const [showQR, setShowQR] = useState(false);
  const [url, setUrl] = useState("");
  const [qrDataUrl, setQrDataUrl] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");

  const [values, setValues] = useState({
    staffId: details?.id || "",
    userId: current?.id,
    userType: details?.user_type || "Activity",
    companyName: details?.company_name || "",
    companyId: details?.company_id || "",
    qrImage: details?.qr_image || "",
    shareUrl: details?.share_url || "",
  });

  const [staffNameMultiple, setStaffNameMultiple] = useState(
    details?.staff_name
      ? details?.staff_name
      : [
          {
            id: 1,
            staffName: "",
          },
        ]
  );

  const fetchData = async (userType) => {
    const resp = await authCall("getUserList", { userType: userType });
    if (resp?.type === "success") {
      const options = resp?.payload.map((s) => ({
        value: s.id,
        label: s.company_name,
      }));
      setHotels(options);
    }
  };

  useEffect(() => {
    fetchData(details?.user_type || "Activity");
    setQrDataUrl(details?.qr_image || "");
  }, []);

  const handleChangeUserType = (selected) => {
    setValues({
      ...values,
      userType: selected.label,
      companyId: "",
      companyName: "",
      shareUrl: "",
    });
    fetchData(selected.label);
  };

  const handleChangeValue = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();
    if (validator.current.allValid()) {
      setLoading(true);
      values.staffName = staffNameMultiple;
      values.qrImage = url ? values.qrImage : "";
      const res = await authCall("createStaff", values);
      if (res?.type === "success") {
        toast.success(res.message);
        setLoading(false);
        navigate(AppConstants.routes.admin.staffList);
      } else {
        setLoading(false);
      }
    } else {
      validator.current.showMessages();
      forceUpdate(1);
      window.scrollTo(0, 0);
    }
  };

  const handleChange = (selected) => {
    const qrCodeUrl = `${shareUrl}?companyName=${encodeURIComponent(
      selected?.label
    )}&companyType=${encodeURIComponent(
      values?.userType
    )}&id=${encodeURIComponent(selected?.value)}`;

    setValues({
      ...values,
      companyId: selected?.value,
      companyName: selected?.label,
      shareUrl: qrCodeUrl,
    });

    setUrl(qrCodeUrl);
    setQrDataUrl("");
  };

  const handleInputChange = (id, event) => {
    setStaffNameMultiple(
      staffNameMultiple.map((field) =>
        field.id === id ? { ...field, staffName: event.target.value } : field
      )
    );
  };

  const addAnotherStaff = () => {
    setStaffNameMultiple([
      ...staffNameMultiple,
      { id: staffNameMultiple.length + 1, staffName: "" },
    ]);
  };

  const removeStaff = (id) => {
    const newStaff = staffNameMultiple.filter((st) => st.id !== id);
    setStaffNameMultiple(newStaff);
  };

  const handleGenerate = async () => {
    if (!url.trim()) return;

    try {
      const dataUrl = await QRCode.toDataURL(url); // Generate QR code as base64 image
      setDownloadUrl(dataUrl);

      // Send to backend
      values.staffName = staffNameMultiple;
      const res = await authCall("generateQRCode", {
        qr: dataUrl,
        name: generateSku(values.companyName),
      });
      if (res?.success === true) {
        setQrDataUrl(res.path);
        setValues({ ...values, qrImage: res.filename });
      }
    } catch (err) {
      console.error(err);
    }
  };

  // const downloadImage = (imageUrl, filename = "qr-code.png") => {
  //   fetch(imageUrl, { mode: "cors" }) // CORS must be allowed by the server
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       const blobUrl = URL.createObjectURL(blob);
  //       const link = document.createElement("a");
  //       link.href = blobUrl;
  //       link.download = filename;
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //       URL.revokeObjectURL(blobUrl); // Clean up
  //     })
  //     .catch((error) => console.error("Download failed:", error));
  // };
  return (
    <>
      <div className="add-machine-page py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-sm-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-sm-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">
                  {details?.id ? "Update" : "Add"} Hotel Staff
                </div>
                <div className="details-wrapper pb-lg-4">
                  <form
                    onSubmit={handleSubmit}
                    className="custom-field-wrapper"
                  >
                    <div className="info-cover mb-2">
                      <div className="main-heading2 mb-2">Hotel Staff:</div>
                      <div className="row mb-2">
                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3"></div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <label htmlFor="userType" className="fs-md-18">
                            User Type:
                          </label>
                          <Select
                            styles={customStyles}
                            className="text-body"
                            placeholder="Select"
                            name="userType"
                            value={{
                              value: values.userType,
                              label: values.userType,
                            }}
                            onChange={handleChangeUserType}
                            options={USERTYPE}
                          />
                          {validator.current.message(
                            "user type",
                            values.userType,
                            "required"
                          )}
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3"></div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <label htmlFor="hotelName" className="fs-md-18">
                            {(values.userType === "Activity" ||
                              values.userType === "Generic") &&
                              "Company Name"}
                            {values.userType === "Restaurant" &&
                              "Restaurant Name"}
                            {values.userType === "Bar" && "Venue Name"}
                            {values.userType === "Hotel" && "Hotel Name"}
                          </label>
                          <Select
                            styles={customStyles}
                            className="text-body"
                            placeholder="Select"
                            name="hotelName"
                            value={hotels.find(
                              (h) => h.value === values.companyId
                            )}
                            onChange={handleChange}
                            options={hotels}
                          />
                          {validator.current.message(
                            "hotel name",
                            values.companyId,
                            "required"
                          )}
                        </div>
                      </div>
                      <div>
                        {staffNameMultiple.map((el, index) => (
                          <div key={index} className="row">
                            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3"></div>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                              <div>
                                <label htmlFor="staffName" className="fs-md-18">
                                  Staff Name:
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="staffName"
                                  name="staffName"
                                  autoComplete="off"
                                  value={el.staffName}
                                  onChange={(e) => handleInputChange(el.id, e)}
                                />
                                {validator.current.message(
                                  "staff name",
                                  staffNameMultiple[index].staffName,
                                  "required"
                                )}
                              </div>
                              {staffNameMultiple.length > 1 && (
                                <div className="text-red text-end">
                                  <span
                                    className="text-red cursor-pointer"
                                    aria-hidden="true"
                                    onClick={() => removeStaff(el.id)}
                                  >
                                    Remove
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                        {!staffNameMultiple?.id && (
                          <div className="fw-medium text-end">
                            <span
                              className="add-another glyphicon glyphicon-plus"
                              aria-hidden="true"
                              onClick={addAnotherStaff}
                            >
                              Add Another Staff
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3"></div>
                      <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                        <div>
                          <label htmlFor="staffName" className="fs-md-18">
                            Share URL:
                          </label>
                          <input
                            disabled
                            type="text"
                            className="form-control"
                            id="staffName"
                            name="staffName"
                            autoComplete="off"
                            value={values.shareUrl}
                          />
                        </div>
                        <Button
                          className="btn btn-custom btn-custom-sm fs-16 mt-2"
                          style={{ float: "right" }}
                          onClick={handleGenerate}
                          disabled={!values.shareUrl || !url}
                        >
                          Generate QR
                        </Button>
                        {validator.current.message(
                          "generate QR",
                          qrDataUrl,
                          "required"
                        )}
                      </div>
                    </div>

                    {qrDataUrl && (
                      <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3"></div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                          <img
                            src={qrDataUrl}
                            style={{
                              backgroundColor: "#fff",
                              marginTop: "15px",
                              width: "120px",
                            }}
                          />
                          <br />
                          <a
                            // href={downloadUrl}
                            href={qrDataUrl}
                            target="_blank"
                            // onClick={() => downloadImage(qrDataUrl, values.qrImage)}
                            download={values.qrImage}
                            className="btn btn-custom btn-custom-sm fs-16 mt-2"
                          >
                            Download
                          </a>
                        </div>
                      </div>
                    )}

                    <hr className="divider my-5" />

                    <div className="btn-wrapper text-center mt-4 mb-2 pt-2">
                      <button
                        type="submit"
                        className="btn btn-custom"
                        disabled={loading || false}
                      >
                        {loading
                          ? "Loading..."
                          : details?.id
                          ? "Update"
                          : "Submit"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddHotelStaff;
